module.exports = __webpack_public_path__ + "public/files/img/ai-data.79036a90.png";